<template>
	<div class="container" id="biotesting_section">
		<BioTestingQuiz />
	</div>
</template>

<script>
import BioTestingQuiz from '../components/BioTestingQuiz.vue';

export default {
	name: 'BioServerQuizView',
	components: {
		BioTestingQuiz,
	},
	props: {},
	data() {
		return {};
	},
	methods: {},
	computed: {},
	created() {},
	mounted() {},
	watch: {},
};
</script>
